// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-069ddc46] .el-tag.el-tag--info {\n  background-color: #d43c3f;\n  color: #ffffff;\n}\n[data-v-069ddc46] .el-tag.el-tag--info .el-tag__close {\n  color: #ffffff;\n  background: #d43c3f;\n  font-size: 16px;\n}\n.org-select-container[data-v-069ddc46] {\n  width: 100%;\n}\n.org-select-container[data-v-069ddc46] .el-select--small {\n  width: 100%;\n}\n.org-select-container .el-select .el-tag__close.el-icon-close[data-v-069ddc46] {\n  top: -7px;\n  right: -4px;\n}", ""]);
// Exports
module.exports = exports;
